import { Pipe, PipeTransform } from '@angular/core';
import { VirtualGridColumn } from '../types/virtual-grid-column';
import { isVirtualGridRow, VirtualGridRow } from '../types/virtual-grid-row';

@Pipe({
  name: 'getPropertyValue'
})
export class GetPropertyValuePipe implements PipeTransform {
  transform(item: VirtualGridRow | any, property: string, column: VirtualGridColumn): any {
    const data: any = (isVirtualGridRow(item) && item.data[property]) || item[property];
    return (column.valueFormatter && column.valueFormatter(item, data, column)) || data;
  }
}
